import language from 'config/language';
import { Status } from 'enums';
import { ThemeColors } from 'providers/Theme';

interface IStatus {
  status: Status;
  min: number;
  max: number;
  label: string;
  color: ThemeColors;
  bgColor: ThemeColors;
}

const brackets = [
  {
    status: Status.INACTIVE,
    min: 0,
    max: 29,
    label: language.health.inactive,
    bgColor: 'brickRed' as const,
    color: 'white' as const,
  },
  {
    status: Status.FAIR,
    min: 30,
    max: 59,
    label: language.health.fair,
    bgColor: 'yellow' as const,
    color: 'black' as const,
  },
  {
    status: Status.HEALTHY,
    min: 60,
    max: 100,
    label: language.health.healthy,
    bgColor: 'softGreen' as const,
    color: 'white' as const,
  },
];

export const getBracketByScore = (score: number): IStatus | undefined => {
  return brackets.find(
    ({ min, max }) => Math.floor(score) >= min && Math.floor(score) <= max,
  );
};

// Determines the health status
export const getStatus = (score: number): Status | undefined => {
  return getBracketByScore(score)?.status;
};

export const getBracketByStatus = (status: Status): IStatus => {
  return brackets[status];
};
